import { useQuery } from "@tanstack/react-query";
import { api, imgUrl } from "@/lib/api";

const norm = (p) => ({ ...p, image: imgUrl(p?.image) });

export function useProducts(params = {}) {
  return useQuery({
    queryKey: ["products", params],
    queryFn: async () => {
      const r = await api.get("/products", { params });
      return Array.isArray(r.data) ? r.data.map(norm) : [];
    },
  });
}

export function useProduct(slug) {
  return useQuery({
    queryKey: ["product", slug],
    queryFn: async () => norm((await api.get(`/products/${slug}`)).data),
    enabled: !!slug,
    retry: false,
  });
}

export function useTestimonials() {
  return useQuery({
    queryKey: ["testimonials"],
    queryFn: async () => {
      const r = await api.get("/testimonials");
      return Array.isArray(r.data) ? r.data.map((t) => ({ ...t, before_image: imgUrl(t.before_image), after_image: imgUrl(t.after_image) })) : [];
    },
  });
}
